import { render, staticRenderFns } from "./MConfirmDialog.vue?vue&type=template&id=15049a8e&"
import script from "./MConfirmDialog.vue?vue&type=script&lang=js&"
export * from "./MConfirmDialog.vue?vue&type=script&lang=js&"
import style0 from "./MConfirmDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports